<template>
  <Shell :label="label" :tooltip="tooltip" class="shrink">
    <template v-slot:label-end>
      <button v-if="multiple && showSelectAll" type="button"
        class="m-0 bg-transparent p-0 text-sm text-gray hover:text-primary"
        @click="toggleAllOptions">{{ allOptionsSelected ? "Deselect All" : "Select All" }}</button>
    </template>
    <template v-slot:comp>
      <treeselect ref="inputElement" class="
          border-b-2 border-gray
          focus:border-primary focus:border-b-2
          w-full
        " style="background: rgba(0, 0, 0, 0); outline: none" :options="_options" v-bind="$attrs"
        :model-value="currentValue" @update:modelValue="emit('update:modelValue', $event)"
        :multiple="multiple" :valueFormat="valueFormat || 'id'" :async="(search && currentValue?.length < 1) || false"
        :name="currentValue === '__other__' ? undefined : $attrs.name" :load-options="(search && currentValue?.length < 1) ? searcher : null"
        searchPromptText="Type at least 4 characters to search..." />
    </template>
  </Shell>
  <Input class="grow" label="Other" :name="$attrs.name" v-if="currentValue === '__other__'" />
</template>
<script setup="props">
import { defineProps, defineComponent, computed, ref } from "vue";
import Shell from "./Shell.vue";
import Input from "./Input.vue";
// disable attributte inheritence
defineComponent({
  inheritAttrs: false
});

const emit = defineEmits(["update:modelValue"]);

// const attrs = useAttrs();
// define the component props
let props = defineProps({
  label: String,
  options: Array,
  multiple: Boolean,
  modelValue: [Array, String, Number, Boolean, Object],
  value: [Array, String, Number, Boolean, Object],
  valueFormat: String,
  search: Boolean,
  hasOther: Boolean,
  showSelectAll: Boolean,
  tooltip: String
});

var delayTimer;

function* getResults(array, searchQuery, maxSize = 25) {
  
  if (!array) return;
  if (!maxSize || maxSize > array.length) {
    maxSize = array.length;
  }

  let count = 0;
  let i = 0;
  while (count < maxSize && i < array.length) {

    if (array[i].label?.toString().toLowerCase().includes(searchQuery?.toLowerCase())) {
      yield array[i];
      count++;
    }
    i++;
  }
};

function searcher({ action, searchQuery, callback }) {
  if (action === "ASYNC_SEARCH" && searchQuery && searchQuery.length >= 3) {
    if (delayTimer) clearTimeout(delayTimer);

    delayTimer = setTimeout(
      callback(null, [...getResults(props.options, searchQuery)]),
      500
    );
  } else if (action === "ASYNC_SEARCH") {
    callback(null, []);
  }
}

const _options = computed(() => {
  return props.hasOther ? [...props.options, {
    "id": "__other__",
    "label": "Other"
  }] : props.options;
});
const inputElement = ref(null);

const currentValue = computed(() => props.modelValue ?? props.value);
const optionIds = computed(() => (props.options || []).map(option => option.id));
const allOptionsSelected = computed(() => {
  if (!optionIds.value.length || !Array.isArray(currentValue.value)) return false;
  return optionIds.value.every(optionId => currentValue.value.includes(optionId));
});

const toggleAllOptions = () => {
  emit("update:modelValue", allOptionsSelected.value ? [] : [...optionIds.value]);
};

defineExpose({ inputElement });
// get the attrb on the component and bind them to the input element

</script>
